import { createAsyncThunk } from "@reduxjs/toolkit";
import { v4 as uuid } from "uuid";
import { FilterTreeNodeWithId } from "@/components/pages/common/filters-tree/utils/types/common";
import { generateDimensionCategoriesFromCategoriesWithCosts } from "@/components/pages/dimensions/utils/helpers/generateDimensionCategoriesFromCategoriesWithCosts";
import { setDimensionsState } from "@/store/dimensions/dimensionsSlice";
import {
  DimensionCategories,
  DimensionsDrawerMode,
} from "@/store/dimensions/utils/types/common";
import { CategoryWithCosts } from "@/services/cloudchipr.api";

interface AddBillingExplorerFilterTreeToDimensionThunkArgs {
  filterTree: FilterTreeNodeWithId;
  drawerMode: DimensionsDrawerMode;
  dimensionId?: string;
  dimensionName: string;
  categories?: CategoryWithCosts[];
}

export const addBillingExplorerFilterTreeToDimensionThunk = createAsyncThunk(
  "resourceExplorer/addBillingExplorerFilterTreeToDimension",
  async (
    {
      filterTree,
      categories,
      dimensionName,
      dimensionId,
      drawerMode,
    }: AddBillingExplorerFilterTreeToDimensionThunkArgs,
    { dispatch },
  ) => {
    const newCategoryId = uuid();
    let localCategories: DimensionCategories = {
      [newCategoryId]: {
        name: "New Category",
        id: newCategoryId,
        filters: {
          filter_tree: filterTree,
        },
      },
    };
    if (categories) {
      localCategories = {
        ...generateDimensionCategoriesFromCategoriesWithCosts(categories),
        ...localCategories,
      };
    }

    dispatch(
      setDimensionsState({
        drawerMode,
        dimensionId,
        dimensionName,
        categories: localCategories,
        sharedCosts: [],
      }),
    );
  },
);
